<div class="print-log-wrapper">
  <div class="print-log-header">
    <div class="print-log-icon">
      <i class="fas fa-history"></i>
    </div>
    <div class="print-log-heading">
      Print Log
    </div>
    <div class="print-log-close">
      <i class="far fa-times" (click)="closeModal()"></i>
    </div>
  </div>
  <div class="print-log-body">
    <div class="print-log-list-wrapper">
      <ul class="print-log-list" *ngIf="isLoading">
        <li class="print-log-list-item" *ngFor="let logs of printLogs">
          <div class="initial-wrapper">
            {{ logs.initial }}
          </div>
          <div class="log-details-wrapper">
            <div class="log-date">
              {{ logs.createdAt }}
            </div>
            <div class="log-list-user">
              <strong>{{ logs.actionBy }}</strong>
              &nbsp;{{getLogsStatus(logs)}}
            </div>
          </div>
        </li>
      </ul>
      <div *ngIf="!isLoading">
        <i class="mt-5 p-2 fal fa-spinner rotate font-30 flex-center-center"></i>
      </div>
      <div *ngIf="isLoading && printLogs && printLogs.length === 0" class="mt-5 flex-center-center">
        No logs
      </div>
    </div>
  </div>
  <div class="print-log-footer" *ngIf="printLogs && printLogs.length > 0">
    <div class="records">Total records: {{ printLogs.length }}</div>
  </div>
</div>
